import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a4aa127e-adf4-4531-8ef7-dbe67663ea5b",
    content: "The width of the lobes<br>decrases with frequency.",
    options: {},
  },
  {
    id: "62ac7cbb-a2e0-4ab5-bae6-18edda9f26c3",
    content: "At very low frequency, the array<br>exhibit an omnidirectional pattern.",
    options: {},
  },
  {
    id: "7d619d0c-63f4-4866-9500-4151c7679589",
    content: "Aliasing occurs when less than<br>2 microphones per wavelength are used.",
    options: {},
  },
  {
    id: "b8203fc7-aedd-43dd-903e-f2359d92b648",
    content: "The width of the lobes increases<br>with the number of microphones.",
    options: {},
  },
  { id: "1fbb19bf-b470-4010-932f-d2125eec984a", content: "The microphone signals<br>are subtracted.", options: {} },
  {
    id: "13bcc85e-2fc8-40d5-9556-38a4f689be99",
    content: "The delay is applied after<br>the microphone signal summation.",
    options: {},
  },
];

export const task: Task = {
  id: "f73a5a4c-72ed-4e5b-8e00-8478393f7764",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "a4aa127e-adf4-4531-8ef7-dbe67663ea5b",
    "62ac7cbb-a2e0-4ab5-bae6-18edda9f26c3",
    "7d619d0c-63f4-4866-9500-4151c7679589",
  ],
};
